export const setSpanStyle = {
  'font-size': '13px',
  float: 'left',
  'user-select': 'none'
}

export const setInputNumberStyle = {
  'border-radius': '0px',
  'margin-left': '10px'
}

export const setInputStyle = {
  'border-radius': '0px',
  'margin-left': '10px',
  width: '150px'
}

export const setDialogInputStyle = {
  'border-radius': '0px',
  'margin-left': '10px',
  width: '60%',
  'background-color': '#cccccc'
}
